export default __webpack_public_path__ + "static/media/pharah-clear.b1067cd1.mp3";